import { post } from '@core/api/baseApi';
import { CreateTemplateResponse} from '@core/types';
import { Payload } from '../types/templatePayload';

export const addTemplate = (payload: Payload): Promise<CreateTemplateResponse > => post('/ReportTemplates', payload);